import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { UPLOAD_ERROR_TRANSLATION_KEYS } from '@/constants';
import { CloseIcon } from '@/resources';
import { UploadErrorDetail } from '@/types';

type ToastProps = {
  text: string;
  details?: UploadErrorDetail[];
  isCollapsible?: boolean;
};

export const CloseToastButton = () => (
  <CloseIcon className='mx-1 mt-2 size-3 cursor-pointer' onClick={() => toast.dismiss()} />
);

export const Toast = ({ text, details = [], isCollapsible = false }: ToastProps) => {
  const [t] = useTranslation('common');
  const [isExpanded, setIsExpanded] = useState(false);

  const hasDetails = details.length > 0;

  return (
    <div className='mx-5 ml-1 flex w-full flex-col gap-2'>
      <div>{text}</div>

      {isCollapsible && hasDetails && (
        <button
          type='button'
          onClick={() => setIsExpanded((prev) => !prev)}
          className='w-fit text-sm font-medium underline'>
          {isExpanded ? t('hideDetails') : t('showDetails')}
        </button>
      )}

      {isExpanded && hasDetails && (
        <div className='flex flex-col gap-1'>
          {details.map((detail, index) => (
            <div key={`${detail.assetName}-${index}`} className='text-sm'>
              <span className='font-semibold'>{detail.assetName}</span>
              <span>{' — '}</span>
              <span>{t(UPLOAD_ERROR_TRANSLATION_KEYS[detail.errorType])}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
